// eslint-disable-next-line import/extensions
import './global.js';
import '~/scss/pages/home.scss';
import Vue from 'vue';
// eslint-disable-next-line import/extensions
import '~/assets/js/utils/assign-polyfill.js';
import VueMq from 'vue-mq';
// eslint-disable-next-line no-unused-vars
import punycode from 'punycode';
import app from '~/components/home/app.vue';

Vue.use(VueMq,
    {
        breakpoints: {
            mobile: 400,
            tablet: 800,
            laptop: 1800,
            desktop: Infinity,
        },
        defaultBreakpoint: 'laptop',
    });

// eslint-disable-next-line no-unused-vars
const scans = new Vue({
    render: (createElement) => createElement(app),
}).$mount('#app');
